module.exports = __webpack_public_path__ + "static/site-1783527333127/img/transbanklogo.4e55d4d6.svg";